import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import NumeralFormat from './NumeralFormat';

export class InputNumber extends Component {
  constructor(props) {
    super(props);

    this.focus = this.focus.bind(this);
  }

  focus() {
    this.input.focus();
  }

  render() {
    const { value, formatProps, formatEnabled, className, ...others } = this.props;

    return (
      <div className="pxl-input-number">
        <Input
          className={`${className} pxl-input-number__input`}
          {...others}
          value={value}
          type="number"
          ref={input => {
            this.input = input;
          }}
        />
        <NumeralFormat value={value} enabled={formatEnabled} {...formatProps} />
      </div>
    );
  }
}

InputNumber.propTypes = {
  className: PropTypes.string,
  formatEnabled: PropTypes.bool,
  formatProps: PropTypes.shape({
    format: PropTypes.func,
    numericFormat: PropTypes.string
  }),
  id: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  tabIndex: PropTypes.number,
  value: PropTypes.any
};

InputNumber.defaultProps = {
  className: '',
  formatEnabled: false,
  formatProps: {},
  tabIndex: 0
};

export default InputNumber;
